"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6v12.0001h20v-12H2zm4.8267 10.0001h2.0646c-.121-2.8116 1.1185-5.0704 3.3601-6.1572 2.105-1.0206 4.8614-.8914 7.7486.4702v-2.313h-6.0715c-3.1294.0198-5.0302 1.347-6.0808 3.0264-.9417 1.5055-1.24 3.3603-1.021 4.9736zm1.0433-8c-.6893.569-1.2608 1.235-1.7179 1.9657-1.1586 1.8521-1.5489 4.0632-1.3396 6.0343H4v-8h3.87zM20 12.5635c-2.8675-1.6192-5.3103-1.6802-6.8761-.921-1.4127.6849-2.3584 2.1605-2.2315 4.3576h1.9177c-.0401-1.4033.775-2.6769 2.1527-3.0903 1.3615-.4084 3.1034-.0275 5.0372 1.1538v-1.5001zm-.68 3.4366c-1.8588-1.1746-3.1332-1.3694-3.7825-1.1746-.5422.1626-.7556.6435-.7259 1.1746H19.32z"
  })];
};

exports.default = _default;